// 用户配置
export const HAS_LOGIN = 'HAS_LOGIN';
export const ROLES = 'ROLES';
export const ROUTES = 'ROUTES';
export const USER_TOKEN = 'USER_TOKEN';
export const USER_AUTHOR = 'USER_AUTHOR';
export const USER_INFO = 'USER_INFO';
export const PERMISSIONS = 'PERMISSIONS';
// 系统配置
export const CONFIG = 'CONFIG';
export const DICT_LIST = 'DICT_LIST';
export const NOTICE_LIST = 'NOTICE_LIST';




// WEBPACK FOOTER //
// ./src/js/vuex/store/mutation-types.js